import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { T } from "../traks";
import { BinaryToggle } from "./BinaryToggle";

export const DataAndAnalysisSection = ({simple_checkbox_change, state}) => {
    return (
        <React.Fragment>
            <span className="txt-15px"><T>Give participants access to essential background information about the stocks and funds they invest in. This leads to better decision-making and a deeper understanding of the real-world stock market.</T></span>
            <Row className="justify-content-center">
                <Col md="12" className="new_game_premium px-md-4 pt-4 pb-4">
                    <img alt="" className="ad_logo_list" src="/gfx/information-about-assets-icon-0.svg" />
                        <span className="ad_120_bold pl-2"><T>Information about assets</T></span>
                            <p>
                                <small><T>Asset data includes the options below and is a good way to give participants insight into the companies they invest in.</T></small><br/>
                            </p>
                        <div className="text-left">
                                <BinaryToggle 
                                    name={"use_stock_info"}
                                    checked={state.use_stock_info}
                                    onChange={simple_checkbox_change}
                                    labels={[<T>Activate</T>, <T>Deactivate</T>]}
                                />
                        </div>
                        <Col className="mt-2">
                            <Row>
                                <Card className="new_game_premium_assets">
                                    <CardBody>
                                        <img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
                                        <p><T>Company information</T></p>
                                    </CardBody>
                                </Card>
                                <Card className="new_game_premium_assets">
                                    <CardBody>
                                        <img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
                                        <p><T>Industry indication</T></p>
                                    </CardBody>
                                </Card>
                                <Card className="new_game_premium_assets">
                                    <CardBody>
                                        <img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
                                        <p><T>Financial information</T></p>
                                    </CardBody>
                                </Card>
                                <Card className="new_game_premium_assets">
                                    <CardBody>
                                        <img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
                                        <p><T>Key figures</T></p>
                                    </CardBody>
                                </Card>
                            </Row>
                        </Col>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/DataAndAnalysisSection.js